import { gql } from "@apollo/client";

export const listCustomizedEarningsById = gql`
  query ListCustomizedEarningsById($id: String!) {
    listCustomizedEarningsById(id: $id) {
      id
      name
      startDate
      endDate
      newQuantity
      isActive
      rewardMappings {
        rewardId
        campaignIds
      }
    }
  }
`;
